import Container from "react-bootstrap/Container";
import FormSection from "../../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../../components/Faq";
import "../../styles/dualEducation.css";
import "../../styles/sliderCalculator.css";
import ResultsSection from "../../components/ResultSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function NemzetiBajnokok() {
  const [loanAmount, setLoanAmount] = useState(150);

  const grantAmount = loanAmount * 0.3;
  const repaymentAmount = loanAmount * 0.7;

  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">GINOP Plusz-1.4.5-25</span>

        <h1 className="title">
          Nemzeti Bajnokok –{" "}
          <span style={{ color: "#c7d2fe" }}>Zöld és digitális átállás</span>
        </h1>

        <p className="subtitle">
          Kombinált hitelprogram vidéki KKV-k részére: <strong>0% kamat</strong>
          , aminek a <strong>30%-a vissza nem térítendő</strong> támogatássá
          alakulhat. Finanszírozás 150 - 600 millió Ft között.
          <br />
          <span className="fw-bold">
            Számold ki, mekkora támogatásra jogosult vállalkozásod!
          </span>
        </p>

        <div className="cta">
          <Button href="#calculation" className="btn btn-primary">
            Számolok
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Kérdésem van!
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-3">
            <Col md={3}>
              <Card className="card">
                <div className="kpi">0% Kamat</div>
                <div className="muted">Fix, kamatmentes finanszírozás</div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">30% Jóváírás</div>
                <div className="muted">
                  A felvett hitelösszeg 30%-a támogatássá alakulhat
                </div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">150-600 M Ft</div>
                <div className="muted">
                  Az igényelhető hitelösszeg a beruházásra
                </div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">Vidéki</div>
                <div className="muted">Budapesten kívüli megvalósítás</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="tevekenysegek" className="section">
          <h2 className="h2">Támogatható tevékenységek</h2>
          <p className="lead">
            A projekt keretében technológiai fejlesztés, digitalizáció és zöld
            energia beruházások valósíthatóak meg.
          </p>

          <Row className="g-3">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Kötelezően megvalósítandó</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <span className="fw-bold">Technológia fejlesztés:</span> Új
                    tárgyi eszköz beszerzése (min. a projekt 30%-a)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Digitális / Megújuló:</strong> Infokommunikációs
                    fejlesztés ÉS/VAGY megújuló energia beruházás (min. 10%)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Elektromos gépjármű:</strong> Beszerzése (max. 25M
                    Ft, az eszközérték max 50%-áig)
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card h-100">
                <h3>Választható elemek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <span className="fw-bold">Építés:</span> Átalakítás,
                    bővítés, felújítás (max. 40-60%)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>K+F:</strong> Kísérleti fejlesztés (max. 25%)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Egyéb:</strong> Képzés (max. 5%), Tanácsadás,
                    Készlet beszerzés (max. 30%, max 50M Ft)
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="calculation">
          <h2 className="h2 mt-5">Kalkulátor – Mekkora támogatást kaphatsz?</h2>
          <section className="slider-calculator section p-0">
            <div className="calculator-wrapper">
              <h3 className="h4">
                Igényelt hitelösszeg:{" "}
                <span className="number">{loanAmount}</span> millió Ft
              </h3>

              <input
                type="range"
                min={150}
                max={600}
                step={10}
                value={loanAmount}
                onChange={(e) => setLoanAmount(Number(e.target.value))}
                className="slider"
              />

              <div className="revenue-block">
                <div className="row">
                  <Col md={6}>
                    <div className="revenue-text">
                      Várható vissza nem térítendő támogatás (30%):
                    </div>
                    <div className="revenue-value">
                      <strong>{grantAmount.toFixed(1)} millió Ft</strong>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="revenue-text">
                      Visszafizetendő hitelösszeg (70%):
                    </div>
                    <div className="revenue-value" style={{ color: "#c7d2fe" }}>
                      <strong>{repaymentAmount.toFixed(1)} millió Ft</strong>
                    </div>
                  </Col>
                </div>
                <div className="disclaimer mt-3">
                  *A 30%-os támogatás az eredményességi kritériumok (BHÉ
                  növekedés és MGFÜ tanácsadás) teljesítése esetén jár.
                </div>
              </div>
            </div>
            <div className="text-center mt-5">
              <Button href="#leadform" className="btn btn-primary">
                Szeretném az előminősítést!
              </Button>
            </div>
          </section>
        </Container>

        <section id="jogosultsag" className="section">
          <h2 className="h2">Kik számára elérhető?</h2>
          <p className="lead">
            A programra olyan vidéki székhelyű KKV-k jelentkezhetnek, akik
            rendelkeznek megfelelő múlttal és árbevétellel.
          </p>
          <Row className="g-3">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Jogosultsági feltételek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Legalább 100M Ft éves árbevétel
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Legalább 3 lezárt üzleti év
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Legalább 5 fős átlagos állományi létszám
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Kettős könyvvitelt vezető gazdasági társaság
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Regisztráció az MGFÜ-nél
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card h-100">
                <h3>Kizáró okok / Korlátozások</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Budapesti megvalósítás (Csak vidéki helyszín!)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Mezőgazdasági termelő vagy élelmiszeripari vállalkozás
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Hitelösszeg &gt; utolsó évi árbevétel
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Saját erő (10%) hiánya
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="leadform">
          <h2 className="h2">Ingyenes előminősítés</h2>
          <p className="lead small">
            Tudd meg 24 órán belül, hogy céged alkalmas-e a Nemzeti Bajnokok
            programra!
          </p>
          <Row>
            <Col md={4}>
              <FormSection formType="Nemzeti Bajnokok" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>0% kamatozású hitel</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Akár 180M Ft vissza nem térítendő támogatás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Teljes körű pályázati ügyintézés</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>MGFÜ regisztráció támogatása</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <Container>
          <h2 className="h2">Eredményeink számokban</h2>
          <ResultsSection />
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Mit jelent az egyműveletes kombinált hitel?",
                    answer:
                      "Azt jelenti, hogy a kölcsön és a vissza nem térítendő támogatás egy folyamatban, egy szerződés keretében dől el. A támogatás a projekt végén, az eredményességi mérés után kerül elszámolásra.",
                  },
                  {
                    question:
                      "Milyen eredményességi kritériumokat kell teljesíteni?",
                    answer:
                      "Két fő feltétel van: 1. Az egy főre eső bruttó hozzáadott érték (BHÉ) növekedése érje el a GDP növekedés 1,5-szeresét. 2. Az MGFÜ által nyújtott szakmai tanácsadás elvégzése. Mindkét feltétel 15-15% támogatást jelent.",
                  },
                  {
                    question: "Mennyi a hitel futamideje?",
                    answer:
                      "Az amortizációs kulcstól függően 24 és 120 hónap között mozoghat.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
